/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { AppIcons } from "../../../data/appIcons";
import { useNavigate, useParams } from "react-router-dom";
import PositionDetail from "../../../features/position/Component/PositionDetail";
import { decryptUrlData } from "../../../services/CryptoService";
import { useLazyGetPositionByIdQuery } from "../../../app/services/jobTitleAPI";
import CardSection from "../../../components/ui/card/CardSection";
import "./position.scss";
import Image from "../../../components/image/Image";
import Checkbox from "../../../components/FinalForms/ui/inputs/checkBox/CheckBox";
import SidebarModal from "../../../components/ui/sidebarModel/SidebarModel";
import AddPosition from "../../../features/position/Component/addPosition";

const ViewPositionDetail = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const positionAppliedId = id ? decryptUrlData(id) : 0;
  const [isModelOpen, setIsModelOpen] = useState(false);

  const [getById, { data }] = useLazyGetPositionByIdQuery();

  useEffect(() => {
    if (positionAppliedId) {
      getById(positionAppliedId);
    }
  }, [positionAppliedId, isModelOpen]);

  //** Back To List */
  const backToList = () => {
    navigate("/Position");
  };

  const handleEditClick = () => {
    setIsModelOpen(true);
  };

  const onSidebarClose = () => {
    setIsModelOpen(false);
  };
  return (
    <>
      <div className="row">
        <div className="col-12 mb-3">
          <div className="top-detail-header-sec">
            <CardSection>
              <div className="job-position-desc">
                <div className="row">
                  <div className="col-xxl-5 col-xl-6 col-lg-6 col-md-6 col-12">
                    <div className="label-value">
                      <span className="label">Job Position Name&nbsp;</span>
                      <span className="value">{data?.positionName}</span>
                    </div>
                  </div>
                  <div className="col-xxl-5 col-xl-5 col-lg-5 col-md-5 col-12">
                    <div className="label-value">
                      <span className="label">Department Name&nbsp;</span>
                      <span className="value">{data?.departmentName}</span>
                    </div>
                  </div>
                  <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-2 col-12">
                    <div className="edit-section">
                      <button title="Edit Position" onClick={handleEditClick}>
                        <Image
                          imagePath={AppIcons.EditIcon}
                          altText="Edit Icon"
                          // onClick={ }
                        />
                      </button>
                    </div>
                  </div>
                  <div className="col-5">
                    <div className="label-value">
                      <span className="label">Description&nbsp;</span>
                      <span className="value">{data?.description}</span>
                    </div>
                  </div>

                  <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-2 col-12">
                    <div className="isActive-section">
                      <Checkbox
                        checkBoxName="isEnable"
                        checkBoxId="isEnable"
                        label="Is Enable"
                        isdisable={true}
                        checked={data?.isEnable}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </CardSection>
          </div>
        </div>
        {/* <div className="col-12 top-space d-flex justify-content-between align-items-center">
          <div className="page-title">
            <h5 className="mb-0">{data?.positionName}</h5>
            <span className="dept-dte">
              <span className="position-dept">{data?.departmentName}</span>
            </span>
          </div>
          <Buttons
            textWithIconFront={true}
            imagePathFront={AppIcons.BackArrowIcon}
            buttonTypeClassName="dark-btn front-arrow"
            onClick={backToList}
            buttonText="Back"
          />
        </div> */}
      </div>
      <div className="position-detail-main">
        <PositionDetail positionAppliedId={positionAppliedId} />
      </div>

      <SidebarModal
        modalTitle="Update Job Position"
        modalSize="w-55"
        onClose={onSidebarClose}
        isOpen={isModelOpen}
      >
        <AddPosition
          positionAppliedId={positionAppliedId}
          isDetailPage={true}
          onSidebarClose={onSidebarClose}
          data={data}
          isEdit={true}
        />
      </SidebarModal>
    </>
  );
};

export default ViewPositionDetail;
